import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// Home Components
import Home from './pages/home/Home';
import Navbar from './pages/home/Navbar';


// Syllabus Components
import Syllabus from './pages/syllabus/Syllabus';
import SyllabusPhys from './pages/syllabus/subjects/SyllabusPhys';
import SyllabusChem from './pages/syllabus/subjects/SyllabusChem';
import SyllabusBio from './pages/syllabus/subjects/SyllabusBio';


// Practice Questions Components
import PracticeQuestions from './pages/practicequestions/PracticeQuestions';
import PracticeQuestionsPhysTopics from './pages/practicequestions/subjects/PracticeQuestionsPhysTopics';
import PracticeQuestionsChemTopics from './pages/practicequestions/subjects/PracticeQuestionsChemTopics';
import PracticeQuestionsBioTopics from './pages/practicequestions/subjects/PracticeQuestionsBioTopics';

// Previous Year Questions Components
import PreviousYearQuestions from './pages/previousyearquestions/PreviousYearQuestions';
import PreviousYearQuestionsPhysTopics from './pages/previousyearquestions/subjects/PreviousYearQuestionsPhysTopics';
import PreviousYearQuestionsChemTopics from './pages/previousyearquestions/subjects/PreviousYearQuestionsChemTopics';
import PreviousYearQuestionsBioTopics from './pages/previousyearquestions/subjects/PreviousYearQuestionsBioTopics';


// Quiz Components
import Quiz from './pages/quiz/Quiz';
import QuizPhysicsTopics from './pages/quiz/subjects/QuizPhysicsTopics';
import QuizChemistryTopics from './pages/quiz/subjects/QuizChemistryTopics';
import QuizBiologyTopics from './pages/quiz/subjects/QuizBiologyTopics';
import QuizStarting from './pages/pages/QuizStarting';
import QuizDetailsPage from './pages/pages/QuizDetailsPage';
import QuizNumber from './pages/pages/QuizNumber';
import NumberOfQuestions from './pages/pages/NumberOfQuestions';
import OnlinePracticsQuestions from './pages/pages/OnlinePracticsQuestions';
import QuestionSolution from './pages/pages/QuestionSolution';
import PageNotFound from './pages/home/PageNotFound';
import BookmarkedQuestions from './pages/pages/BookMarkedQuestions';
import PdfsBookmark from './pages/pages/PdfsBookmark';
import QuestionHistory from './pages/pages/QuestionHistory';
import SubjectProgress from './pages/pages/SubjectProgress';
import TopImportantQuestions from './pages/topimportantquestions/TopImportantQuestions';
import PracticsImportantQuestions from './pages/topimportantquestions/PracticsImportantQuestions';
import PracticsRandomQuestions from './pages/pages/PracticsRandomQuestions';
import PracticsQuestionTopics from './pages/topics/PracticsQuestionTopics';
import PracticeRamdomQuestion from './pages/PracticeRamdomQuestion/PracticeRamdomQuestion';
import QuizReStarting from './pages/pages/QuizReStarting';
import PreviousYearMockTest from './pages/PreviousYearMockTest/PreviousYearMockTest';
import QuizYear from './pages/PreviousYearMockTest/QuizYear';
import NumberOfQuestionsYear from './pages/pages/NumberOfQuestionsYear';
import ChapterWiseWeightage from './pages/ChapterWiseWeightage/ChapterWiseWeightage';
import ChapterWiseWeightagePhysTopics from './pages/ChapterWiseWeightage/subjects/ChapterWiseWeightagePhysTopics';
import ChapterWiseWeightageChemTopics from './pages/ChapterWiseWeightage/subjects/ChapterWiseWeightageChemTopics';
import ChapterWiseWeightageBioTopics from './pages/ChapterWiseWeightage/subjects/ChapterWiseWeightageBioTopics';
import NeetWeightageBiology from './pages/page/NeetWeightageBiology';
import NeetWeightagePhysics from './pages/page/NeetWeightagePhysics';
import NeetWeightageChemistry from './pages/page/NeetWeightageChemistry';
import AllNeetWeightageBiology from './pages/page/AllNeetWeightageBiology';
import AllNeetWeightagePhysics from './pages/page/AllNeetWeightagePhysics';
import AllNeetWeightageChemistry from './pages/page/AllNeetWeightageChemistry';
import Bottombar from './pages/home/Bottombar';
import HelpSupport from './pages/home/HelpSuport';
import About from './pages/home/About';
import PrivacyPolicy from './pages/home/PrivacyPolicy';
import Footer from './pages/home/Footer';
import ContactSupport from './pages/home/Contact';
import PDFViewer from './pages/topics/PDFViwer';
import MoreOptions from './pages/home/MoreOptions';
import NcertBooks from './pages/NcertBook/NcertBooks';
import NcertBookPhysTopics from './pages/NcertBook/subjects/NcertBookPhysTopics';
import NcertBookChemTopics from './pages/NcertBook/subjects/NcertBookChemTopics';
import NcertBookBioTopics from './pages/NcertBook/subjects/NcertBookBioTopics';
import NcertShortNote from './pages/NcertShortNote/NcertShortNote';
import NcertShortNotePhysTopics from './pages/NcertShortNote/subjects/NcertShortNotePhysTopics';
import NcertShortNoteChemTopics from './pages/NcertShortNote/subjects/NcertShortNoteChemTopics';
import NcertShortNoteBioTopics from './pages/NcertShortNote/subjects/NcertShortNoteBioTopics';
import NcertSolutions from './pages/NcertSolution/NcertSolutions';
import NcertSolutionPhysTopics from './pages/NcertSolution/subjects/NcertSolutionPhysTopics';
import NcertSolutionChemTopics from './pages/NcertSolution/subjects/NcertSolutionChemTopics';
import NcertSolutionBioTopics from './pages/NcertSolution/subjects/NcertSolutionBioTopics';
import Formulas from './pages/Formulas/Formulas';
import FormulaPhysTopics from './pages/Formulas/subjects/FormulaPhysTopics';
import FormulaChemTopics from './pages/Formulas/subjects/FormulaChemTopics';
import FormulaBioTopics from './pages/Formulas/subjects/FormulaBioTopics';
import ChapterWisePYQ from './pages/ChapterWisePYQ/ChapterWisePYQ';
import ChapterWisePYQPhysTopics from './pages/ChapterWisePYQ/subjects/ChapterWisePYQPhysTopics';
import ChapterWisePYQChemTopics from './pages/ChapterWisePYQ/subjects/ChapterWisePYQChemTopics';
import ChapterWisePYQBioTopics from './pages/ChapterWisePYQ/subjects/ChapterWisePYQBioTopics';
import DiagramQuestions from './pages/DiagramQuestion/DiagramQuestions';
import DiagramQuestionPhysTopics from './pages/DiagramQuestion/subjects/DiagramQuestionPhysTopics';
import DiagramQuestionChemTopics from './pages/DiagramQuestion/subjects/DiagramQuestionChemTopics';
import DiagramQuestionBioTopics from './pages/DiagramQuestion/subjects/DiagramQuestionBioTopics';
import ReportSend from './pages/home/ReportSend';
import Page from './pages/pages/Page';
import ReportQuestion from './pages/AdminPanel/UserDoubt';
import ReportQuestionDetails from './pages/home/ReportQuestionDetails';
import OnlineReadBook from './pages/pages/OnlineReadBook';
import Flashcards from './pages/Flashcards/Flashcard';
import FlashcardPhysTopics from './pages/Flashcards/subjects/FlashcardPhysTopics';
import FlashcardChemTopics from './pages/Flashcards/subjects/FlashcardChemTopics';
import FlashcardBioTopics from './pages/Flashcards/subjects/FlashcardBioTopics';
import Mindmap from './pages/Mindmaps/Mindmap';
import MindmapPhysTopics from './pages/Mindmaps/subjects/MindmapPhysTopics';
import MindmapChemTopics from './pages/Mindmaps/subjects/MindmapChemTopics';
import MindmapBioTopics from './pages/Mindmaps/subjects/MindmapBioTopics';
import ToperNotes from './pages/ToperNote/ToperNotes';
import ToperNotePhysTopics from './pages/ToperNote/subjects/ToperNotePhysTopics';
import ToperNoteChemTopics from './pages/ToperNote/subjects/ToperNoteChemTopics';
import ToperNoteBioTopics from './pages/ToperNote/subjects/ToperNoteBioTopics';
import Login from './pages/Auth/Login';
import SignUp from './pages/Auth/SignUp';
import Logout from './pages/Auth/Logout';
import Profile from './pages/Auth/Profile';
import UpdateProfile from './pages/Auth/UpdateProfile';
import AccountDelete from './pages/Auth/AccountDelete';
import TermsAndConditions from './pages/home/TermsAndConditions';
import AccountDeletionInstructions from './pages/Auth/AccountDeletionInstructions';
import AdminHome from './pages/AdminPanel/AdminHome';
import AllUsersBeforeLogin from './pages/AdminPanel/AllUsersBeforeLogin';
import AllUsers from './pages/AdminPanel/AllUsers';
import AppInstallUsers from './pages/AdminPanel/AppInstallUsers';
import AppItemsUse from './pages/AdminPanel/AppItemsUse';
import PaymentSuccess from './pages/payments/PaymentSuccess';
import Pay from './pages/payments/Pay';
import PaymentDetails from './pages/payments/PaymentDetails';
import PaymentItems from './pages/AdminPanel/PaymentItems';
import ProductList from './pages/payments/ProductList';
import AllPayments from './pages/AdminPanel/AllPayments';
import PaymentSuccessFail from './pages/payments/PaymentSuccessFail';
import PremiumPaywall from './pages/payments/PremiumPaywall';
import RefundPolicy from './pages/home/RefundPolicy';
import ShippingPolicy from './pages/home/ShippingPolicy';
import PayRazorpay from './pages/payments/PayRazorpay';
import PaymentRazorpay from './pages/payments/PaymentRazorpay';
import MakePayment from './pages/payments/MakePayment';




const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

const AppContent = () => {
  const location = useLocation();

  return (

    <>
      {!location.pathname.startsWith('/quiz-starting') &&
        !location.pathname.startsWith('/quiz-restarting') &&
        <Navbar />}


      {!location.pathname.startsWith('/quiz-starting') &&
        !location.pathname.startsWith('/quiz-restarting') &&
        !location.pathname.startsWith('/online-practics-questions') &&
        !location.pathname.startsWith('/practivs-important-questions') &&
        !location.pathname.startsWith('/practice-random-question/all') &&
        !location.pathname.startsWith('/practice-random-question/physics') &&
        !location.pathname.startsWith('/practice-random-question/chemistry') &&
        !location.pathname.startsWith('/practice-random-question/biology') &&
        !location.pathname.startsWith('/pdfviewer') &&
        !location.pathname.startsWith('/onlinereadbook') &&
        !location.pathname.startsWith('/account-deletion') &&
        !location.pathname.startsWith('/product-list') &&
        !location.pathname.startsWith('/pay-payment') &&
        !location.pathname.startsWith('/pay-razorpay') &&
        !location.pathname.startsWith('/payment-razorpay') &&
        !location.pathname.startsWith('/make-payment') &&
        !location.pathname.startsWith('/payment-success') &&

        <Bottombar />}

      <Routes>
        {/* Public Routes */}
        <Route path='/' element={<Home />} />
        <Route path="/contact" element={<ContactSupport />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<HelpSupport />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
        <Route path="/report-send/:id" element={<ReportSend />} />
        <Route path="/report-question" element={<ReportQuestion />} />
        <Route path="/report-question-details/:id/:displayId/:message" element={<ReportQuestionDetails />} />

        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/update-profile" element={<UpdateProfile />} />
        <Route path="/account-delete" element={<AccountDelete />} />
        <Route path="/account-deletion" element={<AccountDeletionInstructions />} />



        {/* Bckend side page  */}
        <Route path='admin-home' element={<AdminHome />} />
        <Route path="/all-users-data" element={<AllUsers />} />
        <Route path="/all-users-before-login" element={<AllUsersBeforeLogin />} />
        <Route path="/app-install-users" element={<AppInstallUsers />} />
        <Route path="/app-items-use" element={<AppItemsUse />} />
        <Route path="/all-payment-items" element={<PaymentItems />} />
        <Route path="/all-payments" element={<AllPayments />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/shipping-policy" element={<ShippingPolicy />} />


        {/* payments */}
        <Route path="/premium-paywall" element={<PremiumPaywall />} />
        <Route path="/product-list" element={<ProductList />} />
        <Route path="/pay-payment/:item/:userId" element={<Pay />} />
        <Route path="/payment-details/:item/:userId" element={<PaymentDetails />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-success-fail/:payment_id" element={<PaymentSuccessFail />} />
        <Route path="/pay-razorpay" element={<PayRazorpay />} />
        <Route path="/payment-razorpay/:userId" element={<PaymentRazorpay />} />
        <Route path="/make-payment/:userId" element={<MakePayment />} />



        <Route path="/page" element={<Page />} />


        <Route path="/more-options" element={<MoreOptions />} />

        <Route path="/online-practics-questions/:subject/:topic/:type" element={<OnlinePracticsQuestions />} />
        <Route path="/question-solution/:id" element={<QuestionSolution />} />
        <Route path="/bookmarked-questions" element={<BookmarkedQuestions />} />
        <Route path="/bookmarked-pdfs" element={<PdfsBookmark />} />
        <Route path="/questions-history" element={<QuestionHistory />} />
        <Route path="/subject-progress" element={<SubjectProgress />} />
        <Route path="/practice-random-question" element={<PracticeRamdomQuestion />} />
        <Route path="/practice-random-question/:subject" element={<PracticsRandomQuestions />} />
        <Route path="/practice-question-topics" element={<PracticsQuestionTopics />} />
        <Route path="/pdfviewer/:id" element={<PDFViewer />} />
        <Route path="/onlinereadbook/:type/:subject/:topic" element={<OnlineReadBook />} />



        <Route path="/chapter-wise-weightage/physics/neet-physics-weightage" element={<NeetWeightagePhysics />} />
        <Route path="/chapter-wise-weightage/chemistry/neet-chemistry-weightage" element={<NeetWeightageChemistry />} />
        <Route path="/chapter-wise-weightage/biology/neet-biology-weightage" element={<NeetWeightageBiology />} />
        <Route path="/chapter-wise-weightage/physics/all-neet-physics-weightage" element={<AllNeetWeightagePhysics />} />
        <Route path="/chapter-wise-weightage/chemistry/all-neet-chemistry-weightage" element={<AllNeetWeightageChemistry />} />
        <Route path="/chapter-wise-weightage/biology/all-neet-biology-weightage" element={<AllNeetWeightageBiology />} />



        {/* NCERT Books */}
        <Route path="/syllabus" element={<Syllabus />} />
        <Route path="/syllabus/physics" element={<SyllabusPhys />} />
        <Route path="/syllabus/chemistry" element={<SyllabusChem />} />
        <Route path="/syllabus/biology" element={<SyllabusBio />} />

        {/* NCERT Books */}
        <Route path="/ncertbook" element={<NcertBooks />} />
        <Route path="/ncertbook/physics" element={<NcertBookPhysTopics />} />
        <Route path="/ncertbook/chemistry" element={<NcertBookChemTopics />} />
        <Route path="/ncertbook/biology" element={<NcertBookBioTopics />} />

        {/* NCERT Short Note */}
        <Route path="/ncert-short-note" element={<NcertShortNote />} />
        <Route path="/ncert-short-note/physics" element={<NcertShortNotePhysTopics />} />
        <Route path="/ncert-short-note/chemistry" element={<NcertShortNoteChemTopics />} />
        <Route path="/ncert-short-note/biology" element={<NcertShortNoteBioTopics />} />

        {/* NCERT Solution */}
        <Route path="/ncert-solutions" element={<NcertSolutions />} />
        <Route path="/ncert-solutions/physics" element={<NcertSolutionPhysTopics />} />
        <Route path="/ncert-solutions/chemistry" element={<NcertSolutionChemTopics />} />
        <Route path="/ncert-solutions/biology" element={<NcertSolutionBioTopics />} />

        {/* NCERT Formula */}
        <Route path="/formulas" element={<Formulas />} />
        <Route path="/formulas/physics" element={<FormulaPhysTopics />} />
        <Route path="/formulas/chemistry" element={<FormulaChemTopics />} />
        <Route path="/formulas/biology" element={<FormulaBioTopics />} />

        {/* NCERT Flashcard */}
        <Route path="/flashcards" element={<Flashcards />} />
        <Route path="/flashcards/physics" element={<FlashcardPhysTopics />} />
        <Route path="/flashcards/chemistry" element={<FlashcardChemTopics />} />
        <Route path="/flashcards/biology" element={<FlashcardBioTopics />} />

        {/* NCERT MindMap */}
        <Route path="/mindmaps" element={<Mindmap />} />
        <Route path="/mindmaps/physics" element={<MindmapPhysTopics />} />
        <Route path="/mindmaps/chemistry" element={<MindmapChemTopics />} />
        <Route path="/mindmaps/biology" element={<MindmapBioTopics />} />

        {/* Toper Notes */}
        <Route path="/topernote" element={<ToperNotes />} />
        <Route path="/topernote/physics" element={<ToperNotePhysTopics />} />
        <Route path="/topernote/chemistry" element={<ToperNoteChemTopics />} />
        <Route path="/topernote/biology" element={<ToperNoteBioTopics />} />




        {/* Practice Questions */}
        <Route path="/practice-questions" element={<PracticeQuestions />} />
        <Route path="/practice-question-topics/physics" element={<PracticeQuestionsPhysTopics />} />
        <Route path="/practice-question-topics/chemistry" element={<PracticeQuestionsChemTopics />} />
        <Route path="/practice-question-topics/biology" element={<PracticeQuestionsBioTopics />} />

        {/* Previous Year Questions */}
        <Route path="/previous-year-questions" element={<PreviousYearQuestions />} />
        <Route path="/previous-year-questions/physics" element={<PreviousYearQuestionsPhysTopics />} />
        <Route path="/previous-year-questions/chemistry" element={<PreviousYearQuestionsChemTopics />} />
        <Route path="/previous-year-questions/biology" element={<PreviousYearQuestionsBioTopics />} />


        {/* Chapter Wise PYQ */}
        <Route path="/chapter-wise-pyq" element={<ChapterWisePYQ />} />
        <Route path="/chapter-wise-pyq/physics" element={<ChapterWisePYQPhysTopics />} />
        <Route path="/chapter-wise-pyq/chemistry" element={<ChapterWisePYQChemTopics />} />
        <Route path="/chapter-wise-pyq/biology" element={<ChapterWisePYQBioTopics />} />

        {/* Diagram based questions */}
        <Route path="/diagram-based-questions" element={<DiagramQuestions />} />
        <Route path="/diagram-based-questions/physics" element={<DiagramQuestionPhysTopics />} />
        <Route path="/diagram-based-questions/chemistry" element={<DiagramQuestionChemTopics />} />
        <Route path="/diagram-based-questions/biology" element={<DiagramQuestionBioTopics />} />


        {/* Notes */}
        <Route path="/chapter-wise-weightage" element={<ChapterWiseWeightage />} />
        <Route path="/chapter-wise-weightage/physics" element={<ChapterWiseWeightagePhysTopics />} />
        <Route path="/chapter-wise-weightage/chemistry" element={<ChapterWiseWeightageChemTopics />} />
        <Route path="/chapter-wise-weightage/biology" element={<ChapterWiseWeightageBioTopics />} />

        {/* Top impotant questions*/}
        <Route path="/top-important-questions" element={<TopImportantQuestions />} />
        <Route path="/practivs-important-questions/:subject/:name" element={<PracticsImportantQuestions />} />




        {/* Quiz Routes (no navbar) */}
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/quiz/physics" element={<QuizPhysicsTopics />} />
        <Route path="/quiz/chemistry" element={<QuizChemistryTopics />} />
        <Route path="/quiz/biology" element={<QuizBiologyTopics />} />
        <Route path="/quiz-starting/:type/:subject/:topic/:quizNo/:quesNum/:subjectName" element={<QuizStarting />} />
        <Route path="/quiz-restarting/:quizId" element={<QuizReStarting />} />
        <Route path="/quiz-details/:quizId/:type/:subject/:topic/:quizNo/:subjectName" element={<QuizDetailsPage />} />
        <Route path="/quiz-number/:type/:subject/:topic/:subjectName" element={<QuizNumber />} />
        <Route path="/number-of-questions/:type/:subject/:topic/:quizNo/:subjectName" element={<NumberOfQuestions />} />
        <Route path="/number-of-questions-year/:type/:subject/:topic/:quizNo/:subjectName" element={<NumberOfQuestionsYear />} />
        <Route path="*" element={<PageNotFound />} />
        <Route path="/previouse-year-quiz" element={<PreviousYearMockTest />} />
        <Route path="/quiz-year/:type/:subject/:topic/:subjectName" element={<QuizYear />} />

      </Routes>

      {!location.pathname.startsWith('/quiz-starting') &&
        !location.pathname.startsWith('/quiz-restarting') &&
        !location.pathname.startsWith('/online-practics-questions') &&
        !location.pathname.startsWith('/practivs-important-questions') &&
        !location.pathname.startsWith('/practice-random-question/all') &&
        !location.pathname.startsWith('/practice-random-question/physics') &&
        !location.pathname.startsWith('/practice-random-question/chemistry') &&
        !location.pathname.startsWith('/practice-random-question/biology') &&
        !location.pathname.startsWith('/onlinereadbook') &&
        !location.pathname.startsWith('/payment-success') &&


        <Footer />}

    </>

  );
};

export default App;